var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EEEEEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5182_2037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4993 9.04492C13.7469 9.04492 13.135 9.65683 13.135 10.4092C13.135 11.1616 13.7469 11.7735 14.4993 11.7735C15.2517 11.7735 15.8636 11.1616 15.8636 10.4092C15.8636 9.65686 15.2517 9.04492 14.4993 9.04492ZM14.4993 11.0917C14.1231 11.0917 13.8169 10.7854 13.8169 10.4092C13.8169 10.033 14.1231 9.72676 14.4993 9.72676C14.8755 9.72676 15.1818 10.033 15.1818 10.4092C15.1818 10.7854 14.8755 11.0917 14.4993 11.0917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6591 13.1364C21.8475 13.1364 22 12.9848 22 12.7964V11.4329C22 11.3127 21.9368 11.2012 21.8332 11.14L15.1645 7.17964C15.1615 7.17763 15.1585 7.17597 15.1555 7.1743C14.741 6.94461 14.2736 6.93764 13.8351 7.17897L7.1668 11.14C7.06325 11.2012 7 11.3127 7 11.4329V12.7964C7 12.9848 7.15248 13.1364 7.34092 13.1364H8.36365V19.273C7.61156 19.273 7 19.8845 7 20.6365V21.6591C7 21.8475 7.15248 22 7.34092 22H21.6591C21.8475 22 22 21.8476 22 21.6591V20.6365C22 19.8845 21.3885 19.273 20.6364 19.273V13.1364H21.6591ZM21.3182 20.6364V21.3182H7.68181V20.6364C7.68181 20.2605 7.98776 19.9546 8.36362 19.9546H8.70454H20.2955H20.6364C21.0122 19.9545 21.3182 20.2605 21.3182 20.6364ZM9.04546 19.2727V13.1364H10.4091V19.2727H9.04546ZM11.0909 19.2727V13.1364H13.1364V19.2727H11.0909ZM13.8182 19.2727V13.1364H15.1818V19.2727H13.8182ZM15.8636 19.2727V13.1364H17.9091V19.2727H15.8636ZM18.5909 19.2727V13.1364H19.9546V19.2727H18.5909ZM7.68181 12.4546V11.6259L14.1734 7.76937C14.3858 7.65253 14.6115 7.65285 14.8213 7.76704L21.3182 11.6259V12.4546H7.68181Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5182_2037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.705b7b9c7cc4d6ac965bb1a65069a5f1.svg";
export { ForwardRef as ReactComponent };